<template>
    <svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M5 17.3621C5 12.0327 5 9.36793 5.62919 8.47146C6.25839 7.57499 8.76387 6.71733 13.7749 5.00201L14.7295 4.67521C17.3416 3.78106 18.6477 3.33398 20 3.33398C21.3523 3.33398 22.6584 3.78106 25.2705 4.67521L26.2252 5.00201C31.2361 6.71733 33.7416 7.57499 34.3708 8.47146C35 9.36793 35 12.0327 35 17.3621C35 18.1671 35 19.0401 35 19.9867C35 29.3837 27.9351 33.9439 23.5024 35.8802C22.3 36.4055 21.6988 36.6681 20 36.6681C18.3012 36.6681 17.7 36.4055 16.4976 35.8802C12.0649 33.9439 5 29.3837 5 19.9867C5 19.0401 5 18.1671 5 17.3621Z"
            stroke="currentColor"
            stroke-width="1.6"
        />
        <path
            d="M15.833 20.668L18.214 23.3346L24.1663 16.668"
            stroke="currentColor"
            stroke-width="1.6"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
    name: "ShieldCheckIcon",
});
</script>
